/* eslint-disable */
export default {
  tollFree: 'Gratis',
  rcvPmiMeetingTitle: 'Videovergadering van {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
